export const M3SR_DIM = {
  width: 1000,
  height: 450,
};

export const PanelWidth = 200;
export const MenuButtonSize = {
  width: 105,
  height: 55,
};

export const HermMainSizes = {
  main: {
    width: 1280,
    height: 1024,
  },
};

export const percentDimen = (total, percentage) => {
  return `${(total * percentage) / 100}px`;
};
